<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6>
                        <v-autocomplete
                          v-model="filters.gstKeyType"
                          :label="labels.gstKeyType"
                          :items="gstKeyTypeList"
                          item-text="label"
                          data-vv-scope="filter"
                          item-value="value"
                          :error-messages="errors.collect('gstKeyType')"
                          data-vv-name="gstKeyType"
                          :data-vv-as="labels.gstKeyType"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field
                          v-model="filters.gstKeyCode"
                          :label="labels.gstKeyCode"
                          :error-messages="errors.collect('gstKeyCode')"
                          data-vv-scope="filter"
                          data-vv-name="gstKeyCode"
                          :data-vv-as="labels.gstKeyCode"
                          v-validate="'max:2'"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xl3 lg12 xs12>
                        <v-text-field
                          v-model="filters.gstKeyDesc"
                          :label="labels.gstKeyDesc"
                          :error-messages="errors.collect('gstKeyDesc')"
                          data-vv-scope="filter"
                          data-vv-name="gstKeyDesc"
                          :data-vv-as="labels.gstKeyDesc"
                          v-validate="'max:25'"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-flex xs12>
      <message :messages="messages"></message>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew()">
            New GST Key
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td>{{ row.item.gstKeyType }}</td>
                  <td class="text-xs-left">{{ row.item.gstKeyCode }}</td>
                  <td class="text-xs-left">{{ row.item.gstKeyDesc }}</td>
                  <td class="table-action-header">
                    <table-action :rowData="row" review @review="doReview" query @query="doQuery" remove @remove="doPromptRemove"></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
    </v-flex>
    <v-dialog v-model="gstKeyReview" width="1100px" persistent>
      <gstkeycode-review
        :gstKeyForm="gstKeyForm"
        :newGstKey="newGstKey"
        :queryMode="queryMode"
        :reviewMode="reviewMode"
        @close="doClose"
        :loading="loading"
      ></gstkeycode-review>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">Please confirm deletion of this records ( {{ selectedGstKey.gstKeyCode }} ). </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import GstkeycodeReview from './GSTKeyCodeReview'
import { expandURI, filterQuery } from '@/utils/ajax'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'GST Key Type', align: 'left', value: 'gstKeyType' },
        { text: 'GST Key Code', value: 'gstKeyCode' },
        { text: 'Description', value: 'gstKeyDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        gstKeyType: 'GST Key Type',
        gstKeyCode: 'GST Key Code',
        gstKeyDesc: 'Description'
      },
      filters: {
        gstKeyType: null,
        gstKeyCode: null,
        gstKeyDesc: null
      },
      gstKeyForm: {
        gstKeyType: null,
        gstKeyCode: null,
        gstKeyDesc: null,
        createdName: null,
        createdDate: null,
        modifiedName: null,
        modifiedDate: null
      },
      selectedGstKey: {
        gstKeyType: null,
        gstKeyCode: null,
        gstKeyDesc: null
      },
      sideFunction: [
        {
          text: 'Branch',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'gstKeyBrn' }
        }
      ],
      newGstKey: false,
      totalItems: 0,
      gstKeyReview: false,
      loading: false,
      promptRemove: false,
      reviewMode: false,
      queryMode: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  computed: {
    gstMenu() {
      return this.$store.state.gstParam.menu
    },
    gstKeyTypeList() {
      return [
        { label: '01 - Country of Risk', value: '01' },
        { label: '02 - Country of Agent', value: '02' },
        { label: '03 - Country of Cedant', value: '03' },
        { label: '04 - Country of Reinsurer', value: '04' },
        { label: '11 - Branch', value: '11' },
        { label: '21 - Agent GST Registration Status', value: '21' }
      ]
    }
  },
  methods: {
    async doInit(options) {
      const apiURI = this.gstMenu.getGstKeyPage
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((gstKey) => {
                const convertList = {
                  gstKeyType: gstKey.gstKeyType,
                  gstKeyCode: gstKey.gstKeyCode,
                  gstKeyDesc: gstKey.gstKeyDesc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.gstKeyType = null
      this.filters.gstKeyCode = null
      this.filters.gstKeyDesc = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('filter').then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    async doReview(data) {
      this.reviewMode = true
      this.queryMode = false
      this.doFetchData(data)
    },
    async doQuery(data) {
      this.queryMode = true
      this.reviewMode = false
      this.doFetchData(data)
    },
    async doFetchData(data) {
      this.resetMessages()
      const apiURI = this.gstMenu.getGstKey
      const expand = {
        gstKeyCode: data.item.gstKeyCode,
        gstKeyType: data.item.gstKeyType
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.gstKeyForm.gstKeyType = data.gstKey.gstKeyType
          this.gstKeyForm.gstKeyCode = data.gstKey.gstKeyCode
          this.gstKeyForm.gstKeyDesc = data.gstKey.gstKeyDesc
          this.gstKeyForm.createdName = data.gstKey.createdName
          this.gstKeyForm.createdDate = data.gstKey.createdDate
          this.gstKeyForm.modifiedName = data.gstKey.modifiedName
          this.gstKeyForm.modifiedDate = data.gstKey.modifiedDate

          this.newGstKey = false
          this.gstKeyReview = true
        }
      }
    },
    doNew() {
      this.newGstKey = true
      this.gstKeyForm.gstKeyType = null
      this.gstKeyForm.gstKeyCode = null
      this.gstKeyForm.gstKeyDesc = null
      this.gstKeyForm.createdName = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.gstKeyForm.createdDate = new Date()
      this.gstKeyForm.modifiedName = null
      this.gstKeyForm.modifiedDate = null
      this.gstKeyReview = true
    },
    doClose() {
      this.resetMessages()
      this.gstKeyReview = false
      this.doInit(false)
    },
    async doRemove() {
      this.resetMessages()
      const apiURI = this.gstMenu.deleteGstKey
      if (apiURI) {
        const expand = this.selectedGstKey
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(false)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selectedGstKey.gstKeyCode = data.item.gstKeyCode
      this.selectedGstKey.gstKeyType = data.item.gstKeyType
      this.selectedGstKey.gstKeyDesc = data.item.gstKeyDesc
      this.promptRemove = true
    }
  },
  mounted() {
    this.doInit(true)
  },
  components: {
    GstkeycodeReview,
    SideFunctionMenu
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style lang="scss">
</style>
